import React, { useState } from 'react';
import { View } from 'react-native-web';
import { LocStr } from '../utils/Utils';
import {
  File_type_font,
  Font_android_ios,
  Font_android_only,
  Font_Bold,
  Font_Regular,
  Fonts_str,
  In_ios_and_android,
  ok_str,
  Set_font_app,
  Upload_assets,
} from '../utils/DictionaryManagementUtils';
import ImportantNote from '../components/PanelsComponents/Text/ImportantNote';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';
import MyMessagePopup from '../components/MyMessagePopup';
import BreakLine from '../components/PanelsComponents/General/BreakLine';

//= ========================================================================
const Panel_X02_themeFonts = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const listObject = [
    {
      subHeadline: Font_Regular,
      fileId: 'configurations/theme/fonts/custom_font',
    }, {
      subHeadline: Font_Bold,
      fileId: 'configurations/theme/fonts/custom_bold_font',
    },
  ];
  const [messagePopupState, setMessagePopupState] = useState({
    isMessageVisible: false,
    title: '',
  });
  const { fonts } = globJSON.configurations.theme;
  const onValueChanged = (key, value) => {
    fonts[key] = value;
    onConfigChanged();
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Fonts_str}
      paragraph={Set_font_app}
      tooltipsTitles={globJSON.configurations.theme.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >
      <ImportantNote marginBottom={26}>{LocStr(In_ios_and_android, language)}</ImportantNote>
      <SwitcherPanel
        text={Font_android_only}
        value={!globJSON.configurations.theme.fonts.use_custom_android_font_in_keyboard}
        onValueChanged={(value) => {
          onValueChanged('use_custom_android_font_in_keyboard', !value);
        }}
      />
      <SwitcherPanel
        text={Font_android_ios}
        value={!fonts.use_custom_font_in_onboarding_screens}
        onValueChanged={(value) => {
          onValueChanged('use_custom_font_in_onboarding_screens', !value);
        }}
        marginBottom={0}
      />
      {(!fonts.use_custom_android_font_in_keyboard
        || (!fonts.use_custom_font_in_onboarding_screens
          && globJSON.configurations.onboarding.announcement.enable_keyboard_activation_flow)) && (
          <View>
            <BreakLine marginTop={30} />
            <UploadMenu
              globJSON={globJSON}
              onConfigChanged={onConfigChanged}
              setMessagePopupState={setMessagePopupState}
              headline={Upload_assets}
              details={File_type_font}
              listObject={listObject}
              TwoButtonsInARow
            />
          </View>
      )}
      {messagePopupState.isMessageVisible
      && (
        <MyMessagePopup
          onOkPressed={() => setMessagePopupState({
            isMessageVisible: false,
            title: '',
          })}
          okTitle={LocStr(ok_str, language)}
          message={messagePopupState.title}
          language={language}
        />
      )}
    </FullPagePanel>
  );
};

export default Panel_X02_themeFonts;
